const serviceFees: Record<string, string> = {
  LIFT_FEE: "Lift Fee",
  GATE_FEE: "Gate Fee",
  VALET_MOVING_FEE: "Valet/Moving Fee",
  TRANSLOADING: "Transloading",
  CONTAINER_FREIGHT_STABILIZATION: "Container Freight Stabilization",
  DRAYAGE: "Drayage",
  EV_CHARGING: "EV Charging",
  MUDFLAP_REPAIR: "Mudflap Repair",
  TRUCK_OR_TRAILER_WASH: "Truck or Trailer Wash",
  HEADLIGHT_TAILLIGHT_REPAIR_REPLACEMENT: "Headlight/taillight Repair/Replacement",
  TIRE_REPAIR_REPLACEMENT: "Tire Repair/Replacement",
  OIL_CHANGE: "Oil Change",
  GENERAL_CHASSIS_REPAIR: "General Chassis Repair",
  GENERAL_CONTAINER_REPAIR: "General Container Repair",
};

/**
 * Maps a service fee type code (e.g. `LIFT_FEE`) to its display label.
 * @param value Service fee type code from the API
 * @returns The display label, or an empty string when the value is empty or unrecognized
 */
const getServiceFeeDisplayValue = (value: string | null | undefined): string => {
  return value && serviceFees[value] ? serviceFees[value] : "";
};

export { getServiceFeeDisplayValue };
